import { createDecorator } from 'vue-class-component';

export enum Attributes {
    GETTERS = 'getters',
    ACTIONS = 'actions',
    MUTATIONS = 'mutations'
}

export interface ModuleOptions {
    children: any[];
}

function merge(arr: any[], key: string) {
    return arr.reduce((result, it) => ({ ...result, ...it.prototype[key] }), {});
}

function ModulePart(type: string, options?: ModuleOptions) {
    return function(constructor: any) {
        if (constructor.prototype[type] && options && options.children && options.children.length > 0) {
            constructor.prototype[type] = {
                ...constructor.prototype[type],
                ...merge(options.children, type)
            };
        } else if (options && options.children && options.children.length > 0) {
            constructor.prototype[type] = merge(options.children, type);
        }
    };
}

export function Getters(options: ModuleOptions) {
    return ModulePart(Attributes.GETTERS, options);
}

export function Mutations(options?: ModuleOptions) {
    return ModulePart(Attributes.MUTATIONS, options);
}

export function Actions(options?: ModuleOptions) {
    return ModulePart(Attributes.ACTIONS, options);
}

export function ObjectInyect(value: string, attribute: string) {
    return function(target: Object, key: string, descriptor: TypedPropertyDescriptor<any>) {
        if (target.constructor.prototype[attribute]) {
            target.constructor.prototype[attribute] = {
                ...target.constructor.prototype[attribute],
                [value]: descriptor.value
            };
        } else {
            target.constructor.prototype[attribute] = {
                [value]: descriptor.value
            };
        }
    };
}

export function Get(value: string) {
    return ObjectInyect(value, Attributes.GETTERS);
}

export function Mutation(value: string) {
    return ObjectInyect(value, Attributes.MUTATIONS);
}

export function Action(value: string) {
    return ObjectInyect(value, Attributes.ACTIONS);
}

export function extract(module: any, key: string) {
    return module[key];
}

export const subscription = (key?: string | symbol) => {
    return createDecorator((componentOptions, k) => {
        let provide: any = componentOptions.subscriptions;
        if (typeof provide !== 'function' || !provide.managed) {
            componentOptions.subscriptions = function(this: any) {
                return this[k]();
            };
        }
    });
};
